import Swiper from "../lib/swiper";

const MOBILE_MAX = 991;
const MOBILE_INSET = 25;
const MOBILE_GUTTER = 20;
const MOBILE_COLS = 6;

class FlipboxSlider {
  constructor() {
    this.containers = Array.prototype.slice.call(
      document.querySelectorAll(".lc-flipbox-container")
    );
    this.instances = [];
    this.mq = window.matchMedia(`(max-width: ${MOBILE_MAX}px)`);

    if (!this.containers.length) {
      return;
    }

    this.sync();
    this.bindResize();
  }

  bindResize() {
    const onChange = () => this.sync();

    if (typeof this.mq.addEventListener === "function") {
      this.mq.addEventListener("change", onChange);
    } else if (typeof this.mq.addListener === "function") {
      this.mq.addListener(onChange);
    }

    window.addEventListener("resize", () => {
      if (!this.mq.matches) {
        return;
      }
      this.instances.forEach((instance) => {
        if (!instance) {
          return;
        }
        instance.params.slidesOffsetAfter = this.endOffsetAfter(instance.el);
        instance.update();
      });
    });
  }

  /** Peek (1 col) + gutter — lets the last slide rest at the same 25px inset as the first. */
  endOffsetAfter(swiperEl) {
    const width = swiperEl.clientWidth || 0;
    if (!width) {
      return 0;
    }
    const col = (width - MOBILE_INSET - MOBILE_GUTTER * (MOBILE_COLS - 1)) / MOBILE_COLS;
    return col + MOBILE_GUTTER;
  }

  sync() {
    if (this.mq.matches) {
      this.initMobile();
    } else {
      this.destroyAll();
    }
  }

  initMobile() {
    this.containers.forEach((container, index) => {
      if (this.instances[index]) {
        return;
      }

      const el = container.querySelector(".lc-flipbox-container__swiper");
      const pagination = container.querySelector("[data-flipbox-pagination]");
      const slides = container.querySelectorAll(".lc-flipbox");

      if (!el || !slides.length) {
        return;
      }

      slides.forEach((slide) => {
        slide.classList.add("swiper-slide");
      });

      this.instances[index] = new Swiper(el, {
        slidesPerView: "auto",
        spaceBetween: MOBILE_GUTTER,
        slidesOffsetBefore: MOBILE_INSET,
        slidesOffsetAfter: this.endOffsetAfter(el),
        centeredSlides: false,
        watchOverflow: true,
        pagination: pagination
          ? {
              el: pagination,
              clickable: true,
            }
          : undefined,
      });
    });
  }

  destroyAll() {
    this.instances.forEach((instance, index) => {
      if (!instance) {
        return;
      }
      instance.destroy(true, true);
      this.instances[index] = null;
    });
  }
}

export default FlipboxSlider;
